import { Text, View } from '@react-pdf/renderer';
import { MyFleetVessel } from '../../../../models/my-fleet.model';
import {
  getProVesselTypeLabel,
  getRiskLevelColor,
  ProReportNonVesselTypeSpecific,
  ProVesselTypes,
} from '../../../../models/pro.model';
import styles from '../../pro-report-pdf-styles';

interface NonVesselTypeSpecificRiskTableProps {
  report: ProReportNonVesselTypeSpecific;
  vessel?: MyFleetVessel;
}

function NonVesselTypeSpecificRiskTable({
  report,
  vessel,
}: NonVesselTypeSpecificRiskTableProps) {
  if (!report) return null;

  return (
    <View wrap={false} style={styles.table}>
      <View style={styles.tableRow}>
        <Text
          style={{
            ...styles.tableHeaderReducedWidth,
            borderRightWidth: 0,
          }}
        >
          Vessel type
        </Text>
        <Text style={styles.tableHeaderFullWidth}>
          {vessel ? 'Port claims risk**' : 'Port claims risk*'}
        </Text>
      </View>
      {Object.entries(report.risk_level)
        .filter(([vesselType]) => vesselType !== ProVesselTypes.UNKNOWN)
        .map(([vesselType, riskLevel]) => (
          <View style={styles.tableRow} key={vesselType}>
            <Text
              style={{
                ...styles.tableCellReducedWidth,
                borderRightWidth: 0,
                fontWeight: 'bold',
              }}
            >
              {getProVesselTypeLabel(vesselType as ProVesselTypes)}
            </Text>
            <Text
              style={[
                styles.tableCellFullWidth,
                {
                  fontWeight: 'bold',
                  color: getRiskLevelColor(riskLevel),
                },
              ]}
            >
              {riskLevel}
            </Text>
          </View>
        ))}
      <Text style={styles.textAsterix}>
        {vessel
          ? `**Risk levels by vessel type are based on NorthStandard's claims experience and/or correspondents' advice as outlined below.`
          : `*Risk levels by vessel type are based on NorthStandard's claims experience and/or correspondents' advice as outlined below.`}
      </Text>
    </View>
  );
}

NonVesselTypeSpecificRiskTable.defaultProps = {
  vessel: undefined,
};

export default NonVesselTypeSpecificRiskTable;
